import ArrayField from './MultiArrayField';

export default ArrayField;
